import React from 'react';
import moment from 'moment';
import { Modal, Spinner } from 'react-bootstrap';
import { BSModal } from '~/components/Bootstrap';
import { BannerForm, BannerRemove } from '~/components/Admin';
import { BannerType } from '~/services';

interface BannerModalProps {
    banner?: Partial<BannerType>;
    show: boolean;
    setShow: (x: boolean) => void;
}
export function BannerModal({ banner = {}, show, setShow }: BannerModalProps) {
    const formId = 'banner-create-form';
    const [saving, setSaving] = React.useState(false);
    const [valid, setValid] = React.useState(false);
    const hasStarted =
        banner?.start_date && moment(banner.start_date).isSameOrBefore(moment(), 'day');
    const hasEnded = banner?.end_date && moment(banner.end_date).isBefore(moment(), 'day');

    return (
        <BSModal
            show={show}
            onHide={() => setShow(false)}
            aria-labelledby="banner-modal-title"
            id="banner-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title id="banner-modal-title" role="heading" aria-level={1}>
                    {banner?.id ? 'Edit' : 'New'} Banner
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <BannerForm
                    saving={saving}
                    setSaving={setSaving}
                    setShow={setShow}
                    banner={banner}
                    formId={formId}
                    setValid={setValid}
                />
            </Modal.Body>
            <Modal.Footer>
                {banner?.id && !hasEnded && (
                    <BannerRemove bannerId={banner.id}>
                        {hasStarted ? 'Disable' : 'Delete'} Banner
                    </BannerRemove>
                )}
                <button type="button" className="btn btn-secondary" onClick={() => setShow(false)}>
                    Cancel
                </button>
                <button
                    type="submit"
                    className="btn btn-primary"
                    form={formId}
                    disabled={hasEnded || saving || !valid}
                >
                    {saving && (
                        <Spinner animation="border" size="sm" role="status" className="me-2" />
                    )}
                    Submit
                </button>
            </Modal.Footer>
        </BSModal>
    );
}
